import { useSelector } from "react-redux"

export const useAgence = () => {
    const currentAgence = useSelector(state => state.agences?.currentAgence)
    // console.log({ currentAgence });
    return { agence: currentAgence }
}